import React from "react";
import "./Title.css";

export default function AboutUsTitle() {
    return (
        <div className="about-us">
            <h2 className="about-us-title">Sobre nós</h2>
        </div>
    );
}
